import { Controller } from 'react-hook-form';
import Input from '@/components/inputNew';

function InputController({
  type,
  className,
  inputName,
  inputId,
  control,
  label,
  info,
  rules,
  mask,
  inputMode ='text',
}) {
  return (
    <Controller
      name={inputId}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <Input
          mask={mask}
          type={type}
          className={className}
          id={inputId}
          name={inputName}
          label={label}
          value={value}
          error={error?.message || ''}
          onChange={(event) => {
            onChange(event);
          }}
          onBlur={onBlur}
          info={info}
          inputMode={inputMode}
        />
      )}
    />
  );
}
export default InputController;
